import { useDashboardIdentity } from './useDashboardIdentity';
import { useQuery } from '@tanstack/react-query';
import type { ChargerUtilizationResponse } from '@evi/shared';
import { fetchChargerUtilization } from '@/lib/api';

/**
 * Per-charger utilization widget data hook. Live: session and
 * charger events refetch it (LIVE_QUERY_KEYS); no poll.
 */
export function useChargerUtilization() {
  const identity = useDashboardIdentity();
  return useQuery<ChargerUtilizationResponse>({
    queryKey: ['dashboard', identity, 'charger-utilization'],
    queryFn: () => fetchChargerUtilization(),
    staleTime: 60_000,
  });
}
